<template>
  <div v-if="!loading" class="mt-2 mb-4">
    <template v-if="role !== 'admin'">
      <div v-for="(_, index) in restrictions" :key="index" class="d-flex mb-2">
        <div class="mr-2">
          <b-btn variant="outline-danger" @click="remove(index)">
            <b-icon icon="dash" />
          </b-btn>
        </div>
        <div class="w-100">
          <div class="form-group mb-2">
            <selectbox
              v-model="restrictions[index].customer_id"
              :options="availableCustomers(restrictions[index].customer_id)"
              searchable
              placeholder="Vyberte zákazníka"
            >
              <template slot="noResult"> Zákazník nenájdený</template>
            </selectbox>
          </div>
          <div v-if="energeticsRestriction[index]" class="form-group mb-2">
            <selectbox
              v-model="restrictions[index].energetics_id"
              v-validate="'required'"
              :class="{ 'is-invalid': errors.has('erest' + index) }"
              :custom-label="energeticsLabel"
              :name="'erest' + index"
              :options="energeticsRestriction[index]"
              multiple
              searchable
              placeholder="Vyberte odberné miesta"
              @input="onChangeEnergetics(index, $event)"
            >
              <template slot="noResult"> Odberné miesto nenájdené</template>
            </selectbox>
          </div>
        </div>
      </div>
      <b-btn
        v-if="!restrictions.some((i) => i.customer_id === null)"
        variant="outline-primary"
        @click="add"
      >
        <b-icon class="mr-1" icon="plus" scale="1.5x" />
        Pridať oprávnenie
      </b-btn>
    </template>
    <template v-else>
      <div class="alert alert-info">Administrátor má všetky oprávnenia</div>
    </template>
  </div>
</template>
<script>
import Selectbox from '@/components/inputs/Selectbox'

export default {
  components: {
    Selectbox,
  },
  props: {
    role: {
      type: String,
      required: true,
    },
    restrictions: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      loading: false,
      edit: false,
      customers: [],
    }
  },
  computed: {
    energeticsRestriction() {
      let output = []
      for (let i in this.restrictions) {
        if (this.restrictions[i] && this.restrictions[i].customer_id) {
          let customer = this.customers.find(
            (val) => this.restrictions[i].customer_id == val.id,
          )
          output[i] = customer?.energetics
        }
      }
      return output
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(silent = false) {
      this.loading = !silent
      this.$emit('onInit', true)

      this.$api.get('customers/get_customers-w_energetics').then((res) => {
        this.customers = res.data.data
        for (let e in this.customers) {
          this.customers[e].energetics.unshift({
            id: 0,
            name: '-Všetky odberné miesta-',
          })
        }
        if (!silent) {
          this.loading = false
        }
        this.$emit('onLoaded', true)
      })
    },
    availableCustomers(selected) {
      const customers = this.restrictions.map((i) => i.customer_id)
      return this.customers.filter(
        (i) => selected === i.id || !customers.includes(i.id),
      )
    },
    onChangeEnergetics(index) {
      if (this.restrictions[index].energetics_id.includes(0)) {
        this.restrictions[index].energetics_id = []
        this.restrictions[index].energetics_id[0] = 0
      }
    },
    energeticsLabel({ name, powerNumber, gasNumber, waterNumber, heatNumber }) {
      return name || powerNumber || gasNumber || waterNumber || heatNumber
    },
    add() {
      this.restrictions.push({ customer_id: null, energetics_id: null })
    },
    remove(index) {
      this.restrictions.splice(index, 1)
    },
  },
}
</script>
